import React, { FunctionComponent } from "react";

const Personality: FunctionComponent = () => {
  const script = `(function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://woobox.com/js/plugins/woo.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'woobox-sdk'));`;

  return (
    <>
      <div id="woobox-root"></div>
      <script dangerouslySetInnerHTML={{ __html: script }} />
      <div
        className="woobox-offer"
        data-offer="es5m3x"
        data-trigger="enter"
      ></div>
    </>
  );
};

export default Personality;
